import classes from './salesPlanEditForm.module.scss';
import { observer } from 'mobx-react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useSalesPlanEdit } from './useSalesPlanEdit';
import { ProgressSpinner } from 'primereact/progressspinner';
import SummaryModal from './SummaryModal';
import SalesPlanTableLoadingSkeleton from './SalesPlanTableDataSkeleton';
import { InputSwitch } from 'primereact/inputswitch';
import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { salesPlanAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import ConceptDetailsSection from 'screens/FDP/components/ConceptDetails';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import NotesSection from 'screens/FDPScreen/components/NotesSection';
import CopyIcon from 'assets/icons/copyIcon.svg';
import ResetIcon from 'assets/icons/revertIcon.svg';
import { Accordion, AccordionTab } from 'primereact/accordion';

const SalesPlanEditForm = () => {
  const {
    directCOT,
    futureDates,
    userModulesRoles,
    conceptDetails,
    isConceptLoading,
    summaryVisibility,
    salesplanEditData,
    isSalesPlanUpdating,
    savingSingle,
    contractDetails,
    istmsUpdateLoading,
    isSalesDetailsLoading,
    isTMSNotesDataLoading,
    isConceptDetailsLoading,
    isSalesPlanEditDataLoading,
    popup,
    confirmPopup,
    singleSavepopup,
    singleconfirmPopup,
    isMSplanNoteSaving,
    tmsNotesData,
    indirectCOT,
    isDirect,
    finishStatus,
    finishConfirmVisibility,
    setFinishConfirmVisibility,
    isDirectFinish,
    finishConfirmpopup,
    copyRowInfo,
    setFinishConfirmpopup,
    handleFinishSalesplan,
    setIsDirectFinish,
    setIsDirect,
    setIndirectCOT,
    setSingleConfirmPopup,
    setSingleSavepopup,
    setConfirmPopup,
    setPopup,
    setDirectCOT,
    toggleSummaryModalVisibility,
    getSalesSummaryVal,
    getSalesplanValue,
    getSalesplanIsDeramped,
    updateForecastValue,
    handleSaveAllSalesPlan,
    handleSingleSave,
    calculateOverallMS,
    isOldValueCheckBoxVisible,
    toggleOldValuesChekedSwitch,
    isOldValuesCheckBoxChecked,
    handleNavigateToViewScreen,
    checkFinishStatus,
    checkSaveStatus: _checkSaveStatus,
    handleNoteAdd,
    handleCopyButtonClick,
    handleResetButtonClick,
    handleDeleteNote,
    handleEditNote,
    setNoteData,
    removeNoteData,
    isNoteEdited,
    isNoteDeleted,
    directInputFocus,
    indirectInputFocus,
    directFocused,
    indirectFocused,
    handleDirectKeyPress,
    handleIndirectKeyPress,
    handleDirectFocus,
    handleIndirectFocus,
    handleDirectBlur,
    handleIndirectBlur,
  } = useSalesPlanEdit();

  return (
    <div className={classes.targetMarketContainer}>
      <div className={classes.planningContainer}>
        <div className={classes.tmsHeading}>
          <h2>Sales Planning</h2>
        </div>
        {isConceptDetailsLoading || isConceptLoading ? (
          <ConceptDetailsSkeleton />
        ) : (
          <ConceptDetailsSection
            conceptDetails={conceptDetails}
            contractDetails={contractDetails}
            mode="add"
          />
        )}
      </div>

      <div style={{ display: 'flex', gap: '1rem' }}>
        {/* plan container start */}
        <div style={{ width: '90rem', flexGrow: '1' }}>
          {isConceptDetailsLoading || isConceptLoading || isSalesPlanEditDataLoading ? (
            <SalesPlanTableLoadingSkeleton />
          ) : !isSalesPlanEditDataLoading && salesplanEditData.length !== 0 ? (
            <div className={classes.planDetailsContainer}>
              <h4
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span>
                  Plan {futureDates[0].label} - {futureDates[14].label}{' '}
                  <span style={{ color: 'green' }}>*</span>
                </span>
                <span style={{ paddingRight: '3rem' }}>
                  Overall Market Share: {calculateOverallMS()}
                </span>
              </h4>
              {/* Direct Container start */}
              <div
                style={{
                  marginLeft: '0.5rem',
                  marginRight: '0.5rem',
                  marginTop: '0.5rem',
                }}
              >
                <Accordion className={classes.accordianComponent} activeIndex={0}>
                  <AccordionTab header="Direct">
                    <div className={classes.directContainer}>
                      <div
                        style={{
                          margin: '0',
                          height: '4rem',
                          marginBottom: '-2rem',
                        }}
                      >
                        <div className={classes.topHeader}>
                          <div className={classes.saleDetails}>
                            <div>
                              <div
                                style={{
                                  fontSize: '15px',
                                  fontWeight: '600',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                YTD:
                                <span>
                                  {!isSalesDetailsLoading ? (
                                    getSalesSummaryVal(directCOT.value, 'YTD', 'direct')
                                  ) : (
                                    <ProgressSpinner
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      strokeWidth="8"
                                      fill="var(--surface-ground)"
                                      animationDuration="1s"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className={classes.vertical}></div>
                              <div
                                style={{
                                  fontSize: '15px',
                                  fontWeight: '600',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                3MA:
                                <span>
                                  {!isSalesDetailsLoading ? (
                                    getSalesSummaryVal(directCOT.value, '3MA', 'direct')
                                  ) : (
                                    <ProgressSpinner
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      strokeWidth="8"
                                      fill="var(--surface-ground)"
                                      animationDuration="1s"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className={classes.vertical}></div>
                              <div
                                style={{
                                  fontSize: '15px',
                                  fontWeight: '600',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                PM:
                                <span>
                                  {!isSalesDetailsLoading ? (
                                    getSalesSummaryVal(directCOT.value, 'PM', 'direct')
                                  ) : (
                                    <ProgressSpinner
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      strokeWidth="8"
                                      fill="var(--surface-ground)"
                                      animationDuration="1s"
                                    />
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className={classes.directRadioGrp}>
                            <span>
                              <input
                                type="radio"
                                name="directRadio"
                                checked={directCOT.label === 'CMOP'}
                                onClick={() => {
                                  setDirectCOT(() => ({
                                    label: 'CMOP',
                                    value: 'cmop',
                                  }));
                                }}
                              />
                              <label htmlFor="cmop">CMOP</label>
                            </span>
                            <span>
                              <input
                                type="radio"
                                name="directRadio"
                                checked={directCOT.label === 'VA Facility'}
                                onClick={() => {
                                  setDirectCOT(() => ({
                                    label: 'VA Facility',
                                    value: 'va facility',
                                  }));
                                }}
                              />
                              <label htmlFor="va">VA Facility</label>
                            </span>
                            <span>
                              <input
                                type="radio"
                                name="directRadio"
                                checked={directCOT.label === 'TMOP'}
                                onClick={() => {
                                  setDirectCOT(() => ({
                                    label: 'TMOP',
                                    value: 'tmop',
                                  }));
                                }}
                              />
                              <label htmlFor="tmop">TMOP</label>
                            </span>
                            <span>
                              <input
                                type="radio"
                                name="directRadio"
                                checked={directCOT.label === 'MTF'}
                                onClick={() => {
                                  setDirectCOT(() => ({
                                    label: 'MTF',
                                    value: 'mtf',
                                  }));
                                }}
                              />
                              <label htmlFor="mtf">MTF</label>
                            </span>
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              paddingRight: '8px',
                              fontSize: '14px',
                              gap: '0.5rem',
                              marginTop: '-2rem',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                              }}
                            >
                              {isOldValueCheckBoxVisible(directCOT.value, true) && (
                                <>
                                  <span>New values</span>
                                  <InputSwitch
                                    style={{ marginTop: '0' }}
                                    // disabled={isOldValueCheckBoxDisabled(COT.value, true)}
                                    checked={isOldValuesCheckBoxChecked(directCOT.value, true)}
                                    onChange={() =>
                                      toggleOldValuesChekedSwitch(directCOT.value, true)
                                    }
                                  />
                                  <span>Old values</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className={classes.planTable}>
                          <table>
                            <thead>
                              <th>
                                <td>Planning Period</td>
                              </th>
                              <th>
                                <td>Market Forecast</td>
                              </th>
                              <th>
                                <td>Adj Market Forecast</td>
                              </th>
                              <th>
                                <td>TMS</td>
                              </th>
                              <th>
                                <td>MS Plan</td>
                              </th>
                              <th>
                                <td>EU Sales Plan</td>
                              </th>
                              <th style={{ width: '0.5rem' }}></th>
                            </thead>
                            <tbody>
                              {futureDates.map((_, idx) => {
                                const derampTitleDirect = getSalesplanIsDeramped(directCOT.value, 'direct', futureDates[idx].dateString)
                                  ? `NC De-ramp applied — contract term date: ${futureDates[idx].dateString}`
                                  : undefined;
                                return (
                                  <tr
                                    key={idx}
                                    title={derampTitleDirect}
                                    style={{
                                      backgroundColor: `${directFocused === idx ? '#f7f3fe' : ''}`,
                                    }}
                                  >
                                    <td>{futureDates[idx].label}</td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          directCOT.value,
                                          'direct',
                                          futureDates[idx].dateString,
                                          'marketForecast'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      <div className={classes.forecastInputContainer}>
                                        <InputText
                                          type="text"
                                          value={`${getSalesplanValue(
                                            directCOT.value,
                                            'direct',
                                            futureDates[idx].dateString,
                                            'adjforecast'
                                          )}`}
                                          className={classes.forecastInp}
                                          onChange={e => {
                                            updateForecastValue(
                                              e.target.value.replace(/,/g, ''),
                                              futureDates[idx].dateString,
                                              directCOT.value,
                                              true
                                            );
                                          }}
                                          ref={(el: HTMLInputElement) =>
                                            (directInputFocus.current[idx] = el)
                                          }
                                          onKeyDown={e => handleDirectKeyPress(e, idx)}
                                          onFocus={() => {
                                            handleDirectFocus(idx);
                                          }}
                                          onBlur={() => {
                                            handleDirectBlur();
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          directCOT.value,
                                          'direct',
                                          futureDates[idx].dateString,
                                          'tmsvalue'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          directCOT.value,
                                          'direct',
                                          futureDates[idx].dateString,
                                          'msplan'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          directCOT.value,
                                          'direct',
                                          futureDates[idx].dateString,
                                          'euforecast'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      <div
                                        style={{
                                          marginTop: '0',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '0.5rem',
                                        }}
                                      >
                                        <Button
                                          style={{
                                            height: '28px',
                                            width: '28px',
                                          }}
                                          icon={
                                            <img
                                              src={CopyIcon}
                                              style={{
                                                height: '20px',
                                                width: '20px',
                                                cursor: 'pointer',
                                                opacity: '0.8',
                                              }}
                                            />
                                          }
                                          disabled={
                                            getSalesplanValue(
                                              directCOT.value,
                                              'direct',
                                              futureDates[idx].dateString,
                                              'adjforecast'
                                            ) == '-'
                                              ? true
                                              : false
                                          }
                                          onClick={() => {
                                            handleCopyButtonClick(true, idx);
                                          }}
                                          rounded
                                          text
                                          aria-label="Filter"
                                        />
                                        {copyRowInfo.has(
                                          directCOT.value.toLowerCase() +
                                            futureDates[idx].dateString +
                                            'direct'
                                        ) ? (
                                          <Button
                                            style={{
                                              height: '28px',
                                              width: '28px',
                                            }}
                                            icon={
                                              <img
                                                src={ResetIcon}
                                                style={{
                                                  height: '20px',
                                                  width: '20px',
                                                  cursor: 'pointer',
                                                  opacity: '0.8',
                                                }}
                                              />
                                            }
                                            disabled={
                                              getSalesplanValue(
                                                directCOT.value,
                                                'direct',
                                                futureDates[idx].dateString,
                                                'adjforecast'
                                              ) == '-'
                                                ? true
                                                : false
                                            }
                                            onClick={() => {
                                              handleResetButtonClick(true, idx);
                                            }}
                                            rounded
                                            text
                                            aria-label="Filter"
                                          />
                                        ) : (
                                          <div></div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className={classes.categoryButtonGroup}>
                      <Button
                        className={classes.saveBtnStyle}
                        onClick={() => {
                          setIsDirect(true);
                          setSingleSavepopup(prev => !prev);
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        className={classes.finishBtnStyle}
                        onClick={() => {
                          setIsDirectFinish(true);
                          setFinishConfirmVisibility(prev => !prev);
                        }}
                      >
                        Finish
                      </Button>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
              {/* Direct Container end */}
              <hr />
              {/* Indirect Container start */}
              <div
                style={{
                  marginLeft: '0.5rem',
                  marginRight: '0.5rem',
                  marginTop: '0.5rem',
                }}
              >
                <Accordion className={classes.accordianComponent}>
                  <AccordionTab header="Indirect">
                    <div className={classes.directContainer}>
                      <div style={{ marginTop: '0rem' }}>
                        <div className={classes.topHeader}>
                          <div className={classes.saleDetails}>
                            <div>
                              <div
                                style={{
                                  fontSize: '15px',
                                  fontWeight: '600',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                YTD:
                                <span>
                                  {!isSalesDetailsLoading ? (
                                    getSalesSummaryVal(indirectCOT.value, 'YTD', 'indirect')
                                  ) : (
                                    <ProgressSpinner
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      strokeWidth="8"
                                      fill="var(--surface-ground)"
                                      animationDuration="1s"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className={classes.vertical}></div>
                              <div
                                style={{
                                  fontSize: '15px',
                                  fontWeight: '600',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                3MA:
                                <span>
                                  {!isSalesDetailsLoading ? (
                                    getSalesSummaryVal(indirectCOT.value, '3MA', 'indirect')
                                  ) : (
                                    <ProgressSpinner
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      strokeWidth="8"
                                      fill="var(--surface-ground)"
                                      animationDuration="1s"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className={classes.vertical}></div>
                              <div
                                style={{
                                  fontSize: '15px',
                                  fontWeight: '600',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                PM:
                                <span>
                                  {!isSalesDetailsLoading ? (
                                    getSalesSummaryVal(indirectCOT.value, 'PM', 'indirect')
                                  ) : (
                                    <ProgressSpinner
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                        padding: 0,
                                        margin: 0,
                                      }}
                                      strokeWidth="8"
                                      fill="var(--surface-ground)"
                                      animationDuration="1s"
                                    />
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className={classes.directRadioGrp}>
                            <span>
                              <input
                                type="radio"
                                name="indirectRadio"
                                checked={indirectCOT.label === 'CMOP'}
                                onClick={() => {
                                  setIndirectCOT(() => ({
                                    label: 'CMOP',
                                    value: 'cmop',
                                  }));
                                }}
                              />
                              <label htmlFor="cmop">CMOP</label>
                            </span>
                            <span>
                              <input
                                type="radio"
                                name="indirectRadio"
                                checked={indirectCOT.label === 'VA Facility'}
                                onClick={() => {
                                  setIndirectCOT(() => ({
                                    label: 'VA Facility',
                                    value: 'va facility',
                                  }));
                                }}
                              />
                              <label htmlFor="va">VA Facility</label>
                            </span>
                            <span>
                              <input
                                type="radio"
                                name="indirectRadio"
                                checked={indirectCOT.label === 'TMOP'}
                                onClick={() => {
                                  setIndirectCOT(() => ({
                                    label: 'TMOP',
                                    value: 'tmop',
                                  }));
                                }}
                              />
                              <label htmlFor="tmop">TMOP</label>
                            </span>
                            <span>
                              <input
                                type="radio"
                                name="indirectRadio"
                                checked={indirectCOT.label === 'MTF'}
                                onClick={() => {
                                  setIndirectCOT(() => ({
                                    label: 'MTF',
                                    value: 'mtf',
                                  }));
                                }}
                              />
                              <label htmlFor="mtf">MTF</label>
                            </span>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              paddingRight: '8px',
                              fontSize: '14px',
                              gap: '0.5rem',
                              marginTop: '0',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                              }}
                            >
                              {isOldValueCheckBoxVisible(indirectCOT.value, false) && (
                                <>
                                  <span>New values</span>
                                  <InputSwitch
                                    style={{ marginTop: '0' }}
                                    // disabled={isOldValueCheckBoxDisabled(COT.value, true)}
                                    checked={isOldValuesCheckBoxChecked(indirectCOT.value, false)}
                                    onChange={() =>
                                      toggleOldValuesChekedSwitch(indirectCOT.value, false)
                                    }
                                  />
                                  <span>Old values</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className={classes.planTable} style={{ marginTop: '-1rem' }}>
                          <table>
                            <thead>
                              <th>
                                <td>Planning Period</td>
                              </th>
                              <th>
                                <td>Market Forecast</td>
                              </th>
                              <th>
                                <td>Adj Market Forecast</td>
                              </th>
                              <th>
                                <td>TMS</td>
                              </th>
                              <th>
                                <td>MS Plan</td>
                              </th>
                              <th>
                                <td>EU Sales Plan</td>
                              </th>
                              <th style={{ width: '0.5rem' }}></th>
                            </thead>
                            <tbody>
                              {futureDates.map((_, idx) => {
                                const derampTitleIndirect = getSalesplanIsDeramped(indirectCOT.value, 'indirect', futureDates[idx].dateString)
                                  ? `NC De-ramp applied — contract term date: ${futureDates[idx].dateString}`
                                  : undefined;
                                return (
                                  <tr
                                    key={idx}
                                    title={derampTitleIndirect}
                                    style={{
                                      backgroundColor: `${
                                        indirectFocused === idx ? '#f7f3fe' : ''
                                      }`,
                                    }}
                                  >
                                    <td>{futureDates[idx].label}</td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          indirectCOT.value,
                                          'indirect',
                                          futureDates[idx].dateString,
                                          'marketForecast'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: '#7B4B9F',
                                        fontWeight: '600',
                                      }}
                                    >
                                      <div className={classes.forecastInputContainer}>
                                        <InputText
                                          type="text"
                                          value={`${getSalesplanValue(
                                            indirectCOT.value,
                                            'indirect',
                                            futureDates[idx].dateString,
                                            'adjforecast'
                                          )}`}
                                          className={classes.forecastInp}
                                          onChange={e => {
                                            updateForecastValue(
                                              e.target.value.replace(/,/g, ''),
                                              futureDates[idx].dateString,
                                              indirectCOT.value,
                                              false
                                            );
                                          }}
                                          ref={(el: HTMLInputElement) =>
                                            (indirectInputFocus.current[idx] = el)
                                          }
                                          onKeyDown={e => handleIndirectKeyPress(e, idx)}
                                          onFocus={() => {
                                            handleIndirectFocus(idx);
                                          }}
                                          onBlur={() => {
                                            handleIndirectBlur();
                                          }}
                                        />
                                      </div>
                                    </td>

                                    <td style={{ fontWeight: '600' }}>
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          indirectCOT.value,
                                          'indirect',
                                          futureDates[idx].dateString,
                                          'tmsvalue'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          indirectCOT.value,
                                          'indirect',
                                          futureDates[idx].dateString,
                                          'msplan'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      {!istmsUpdateLoading ? (
                                        getSalesplanValue(
                                          indirectCOT.value,
                                          'indirect',
                                          futureDates[idx].dateString,
                                          'euforecast'
                                        )
                                      ) : (
                                        <ProgressSpinner
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            padding: 0,
                                            margin: 0,
                                          }}
                                          strokeWidth="8"
                                          fill="var(--surface-ground)"
                                          animationDuration="1s"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      <div
                                        style={{
                                          marginTop: '0',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '0.5rem',
                                        }}
                                      >
                                        <Button
                                          style={{
                                            height: '28px',
                                            width: '28px',
                                          }}
                                          icon={
                                            <img
                                              src={CopyIcon}
                                              style={{
                                                height: '20px',
                                                width: '20px',
                                                cursor: 'pointer',
                                                opacity: '0.8',
                                              }}
                                            />
                                          }
                                          disabled={
                                            getSalesplanValue(
                                              indirectCOT.value,
                                              'indirect',
                                              futureDates[idx].dateString,
                                              'adjforecast'
                                            ) == '-'
                                              ? true
                                              : false
                                          }
                                          onClick={() => {
                                            handleCopyButtonClick(false, idx);
                                          }}
                                          rounded
                                          text
                                          aria-label="Filter"
                                        />
                                        {copyRowInfo.has(
                                          indirectCOT.value.toLowerCase() +
                                            futureDates[idx].dateString +
                                            'indirect'
                                        ) ? (
                                          <Button
                                            style={{
                                              height: '28px',
                                              width: '28px',
                                            }}
                                            icon={
                                              <img
                                                src={ResetIcon}
                                                style={{
                                                  height: '20px',
                                                  width: '20px',
                                                  cursor: 'pointer',
                                                  opacity: '0.8',
                                                }}
                                              />
                                            }
                                            disabled={
                                              getSalesplanValue(
                                                indirectCOT.value,
                                                'indirect',
                                                futureDates[idx].dateString,
                                                'adjforecast'
                                              ) == '-'
                                                ? true
                                                : false
                                            }
                                            onClick={() => {
                                              handleResetButtonClick(false, idx);
                                            }}
                                            rounded
                                            text
                                            aria-label="Filter"
                                          />
                                        ) : (
                                          <div></div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className={classes.categoryButtonGroup}>
                      <Button
                        className={classes.saveBtnStyle}
                        onClick={() => {
                          setIsDirect(false);
                          setSingleSavepopup(prev => !prev);
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        className={classes.finishBtnStyle}
                        onClick={() => {
                          setIsDirectFinish(false);
                          setFinishConfirmVisibility(prev => !prev);
                        }}
                      >
                        Finish
                      </Button>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
              {/* Indirect Container end */}
              <div className={classes.bottomBtngroup}>
                <Button
                  style={{
                    backgroundColor: '#4D2E6D',
                    color: '#FFFFFF',
                    fontWeight: 600,
                    border: 'none',
                  }}
                  onClick={toggleSummaryModalVisibility}
                >
                  Show Summary
                </Button>
                <div>
                  <Button
                    style={{
                      backgroundColor: '#D8000C',
                      color: '#FFFFFF',
                      fontWeight: 600,
                      border: 'none',
                    }}
                    onClick={handleNavigateToViewScreen}
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{
                      backgroundColor: '#4D2E6D',
                      color: '#FFFFFF',
                      fontWeight: 600,
                      border: 'none',
                    }}
                    onClick={() => setPopup(() => true)}
                    disabled={
                      !checkIfFunctionalityEnabled(
                        salesPlanAllowedRoles.createNewSalesPlan,
                        userModulesRoles.fdp,
                        userModulesRoles
                      ) || checkFinishStatus()
                    }
                  >
                    Finish All
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <div className={classes.noSalesPlanContainer}>No Sales plan edit data available!!</div>
          )}
        </div>
        {/* plan container end */}

        <div style={{ marginTop: '0.5rem' }}>
          <NotesSection
            mode="edit"
            isNotesDataLoading={
              isTMSNotesDataLoading || isConceptDetailsLoading || isConceptLoading
            }
            isNoteAddLoading={isMSplanNoteSaving}
            notesData={tmsNotesData}
            setNoteData={setNoteData}
            removeNoteData={removeNoteData}
            handleAddNote={handleNoteAdd}
            handleEditNote={handleEditNote}
            editLoading={isNoteEdited}
            handleDeleteNote={handleDeleteNote}
            deleteLoading={isNoteDeleted}
            isAddNewButtonDisabled={
              !checkIfFunctionalityEnabled(
                salesPlanAllowedRoles.createNewSalesPlan,
                userModulesRoles.fdp,
                userModulesRoles
              )
            }
          />
        </div>
      </div>

      {/* Finish modal start */}
      <ConfirmationModal
        visibility={finishConfirmVisibility}
        modalHeading=""
        modalContent={`Create Sales plan for all COTs for ${
          isDirectFinish ? 'Direct' : 'Indirect'
        } mode for the concept - ${conceptDetails?.concept}`}
        confirmLabel="Create"
        handleCancel={() => setFinishConfirmVisibility(prev => !prev)}
        handleConfirm={() => setFinishConfirmpopup(prev => !prev)}
      />

      <ConfirmationModal
        visibility={finishConfirmpopup}
        modalHeading="Confirmation"
        modalContent="Are you sure want to update the Sales Plan?"
        confirmLabel="Yes"
        cancelLabel="No"
        loading={finishStatus}
        handleCancel={() => {
          setFinishConfirmVisibility(prev => !prev);
          setFinishConfirmpopup(prev => !prev);
        }}
        handleConfirm={async () => {
          await handleFinishSalesplan();
          setFinishConfirmVisibility(false);
          setFinishConfirmpopup(false);
        }}
      />
      {/* Finish modal end */}

      {/* Finish all modal start */}
      <ConfirmationModal
        visibility={popup}
        modalHeading=""
        modalContent={`Create Sales plan for all COTs for the concept - ${conceptDetails?.concept}`}
        confirmLabel="Create"
        handleCancel={() => setPopup(prev => !prev)}
        handleConfirm={() => setConfirmPopup(prev => !prev)}
      />

      <ConfirmationModal
        visibility={confirmPopup}
        modalHeading="Confirmation"
        modalContent="Are you sure want to update the Sales Plan?"
        confirmLabel="Yes"
        cancelLabel="No"
        loading={isSalesPlanUpdating}
        handleCancel={() => {
          setConfirmPopup(prev => !prev);
          setPopup(prev => !prev);
        }}
        handleConfirm={async () => {
          await handleSaveAllSalesPlan();
          setConfirmPopup(false);
          setPopup(false);
        }}
      />
      {/* Finish all modal end */}

      {/* Single save modal start */}
      <ConfirmationModal
        visibility={singleSavepopup}
        modalHeading=""
        modalContent={`Create Sales plan for ${
          isDirect ? directCOT.label : indirectCOT.label
        } in ${isDirect ? 'Direct' : 'Indirect'} category for the concept - ${
          conceptDetails?.concept
        }`}
        confirmLabel="Create"
        handleCancel={() => setSingleSavepopup(prev => !prev)}
        handleConfirm={() => setSingleConfirmPopup(prev => !prev)}
      />
      <ConfirmationModal
        visibility={singleconfirmPopup}
        modalHeading="Confirmation"
        modalContent="Are you sure want to update the Sales Plan?"
        confirmLabel="Yes"
        cancelLabel="No"
        loading={savingSingle}
        handleCancel={() => {
          setSingleConfirmPopup(prev => !prev);
          setSingleSavepopup(prev => !prev);
        }}
        handleConfirm={async () => {
          await handleSingleSave();
          setSingleConfirmPopup(false);
          setSingleSavepopup(false);
        }}
      />
      {/* Single save modal end */}

      <SummaryModal
        visibility={summaryVisibility}
        toggleVisibility={toggleSummaryModalVisibility}
        planningMonths={futureDates}
        getSalesplanValue={getSalesplanValue}
      />
    </div>
  );
};

export default observer(SalesPlanEditForm);
